var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useMemo, useState } from 'react';

import { Link, useLoaderData, useRevalidator } from 'react-router';
import { useSetAtom, useAtomValue } from 'jotai';
import { Translate } from "../../../../I18N";
import * as ThesauriAPI from "../../../api/thesauri";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, ConfirmationModal } from "../../../Components/UI";
import { notificationAtom, templatesAtom } from "../../../atoms";

import { ThesauriTable } from "./components/ThesauriTable";


const thesauriLoader =
(headers) =>
async () =>
ThesauriAPI.get({}, headers);

const ThesauriList = () => {
  const revalidator = useRevalidator();
  const thesauri = useLoaderData();
  const setNotifications = useSetAtom(notificationAtom);
  const templates = useAtomValue(templatesAtom);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [currentThesauri, setCurrentThesauri] = useState([]);
  const [selectedThesauri, setSelectedThesauri] = useState([]);

  useMemo(() => {
    setCurrentThesauri(
      thesauri.map((thesaurus) => {
        const templatesUsingIt = templates.
        map((t) => {var _t$properties;
          const usingIt = (_t$properties = t.properties) === null || _t$properties === void 0 ? void 0 : _t$properties.some(
            (property) => property.content === thesaurus._id
          );
          return usingIt ? t : null;
        }).
        filter((t) => t);
        return _objectSpread(_objectSpread({},
        thesaurus), {}, {
          rowId: thesaurus._id,
          templates: templatesUsingIt,
          disableRowSelection: Boolean(templatesUsingIt.length) });

      })
    );
  }, [thesauri, templates]);

  const deleteSelectedThesauri = async () => {
    try {
      const requests = selectedThesauri.map(async (thesaurus) =>
      ThesauriAPI.deleteThesauri({ _id: thesaurus._id })
      );
      await Promise.all(requests);
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesauri deleted")
      });
    } catch (e) {
      setNotifications({
        type: 'error',
        text: e.message
      });
    } finally {
      await revalidator.revalidate();
      setShowConfirmationModal(false);
    }
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "w-full h-full overflow-y-auto", "data-testid": "settings-thesauri" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Thesauri" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { "data-testid": "thesauri" }, void 0, /*#__PURE__*/
    _jsx(ThesauriTable, {
      currentThesauri: currentThesauri,
      setSelectedThesauri: setSelectedThesauri }
    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: "bg-indigo-50", highlighted: true }, void 0,
    selectedThesauri.length ? /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: () => setShowConfirmationModal(true),
      color: "error",
      "data-testid": "thesaurus-delete-link" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selectedThesauri.length, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "of"), ' ',
    thesauri.length
    ) : /*#__PURE__*/

    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Link, { to: "/settings/thesauri/new" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "button" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add thesaurus")
    )
    )
    )
    )

    )
    ),
    showConfirmationModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      size: "lg",
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
      warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, "Are you sure you want to delete this item?"),
      body: /*#__PURE__*/
      _jsx("ul", { className: "flex flex-wrap max-w-md gap-8 list-disc list-inside" }, void 0,
      selectedThesauri.map((item) => /*#__PURE__*/
      _jsx("li", {}, item.name, item.name)
      )
      ),

      onAcceptClick: deleteSelectedThesauri,
      onCancelClick: () => setShowConfirmationModal(false),
      dangerStyle: true }
    )

    ));

};

export { ThesauriList, thesauriLoader };